/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAbbreviatedTalent } from './AbbreviatedTalent';

export interface PatchPollsRequest {

    type?: string;

    title?: string;

    description?: string;

    image?: string;

    opens_at?: string;

    closes_at?: string;

    vote_changeable?: boolean;

    membership_required?: boolean;

    hide_results_before_voting?: boolean;

    hide_results_after_voting?: boolean;

    featured_until?: string;

    featured_at?: string;

    featured_expires_at?: string;

    topic_id?: string;

    offer_set_id?: number;

    endorsements?: ApiAbbreviatedTalent[];

}

@Model('PatchPolls')
export class ApiPatchPolls extends BaseModel implements PatchPollsRequest {

    
    
    type: string;

    
    
    title: string;

    
    
    description: string;

    
    
    image: string;

    
    
    opens_at: string;

    
    
    closes_at: string;

    
    
    vote_changeable: boolean;

    
    
    membership_required: boolean;

    
    
    hide_results_before_voting: boolean;

    
    
    hide_results_after_voting: boolean;

    
    
    featured_until: string;

    
    
    featured_at: string;

    
    
    featured_expires_at: string;

    
    
    topic_id: string;

    
    
    offer_set_id: number;

    @Type('ApiAbbreviatedTalent')
    @Expand()
    endorsements: ApiAbbreviatedTalent[];

}
